import { createBrowserHistory, createMemoryHistory } from 'history';
import { isServer } from './server.helper';
import { SUPPORTED_ZONE_PREFIXES } from '../constants/app.constants';

/**
 * Detect the zone prefix from a pathname.
 * Returns '' when no known prefix is present (standalone / unprefixed mount).
 */
export const detectBasename = (pathname = '') => {
  const match = SUPPORTED_ZONE_PREFIXES.find(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
  return match || '';
};

// Resolve once at module load on the client. On the server, per-request
// basename is derived from req.path in server/app.js.
export const BASENAME = isServer ? '' : detectBasename(window.location.pathname);

export const history = isServer
  ? createMemoryHistory({
      initialEntries: ['/'],
    })
  : createBrowserHistory({ basename: BASENAME });